import { render, staticRenderFns } from "./AuthSetPassword.vue?vue&type=template&id=f82f6756"
import script from "./AuthSetPassword.vue?vue&type=script&lang=js"
export * from "./AuthSetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports